import { render, staticRenderFns } from "./limitedWelfare.vue?vue&type=template&id=40c11608"
import script from "./limitedWelfare.vue?vue&type=script&lang=js"
export * from "./limitedWelfare.vue?vue&type=script&lang=js"
import style0 from "./limitedWelfare.vue?vue&type=style&index=0&id=40c11608&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports